require('./style.less');

var PageImageWr = require('../page'),
    DocModePgImgWr = require('../docMode/pageDocMode');

/**
 * The base is an image ... so inherit from page image wrapper
 */

var ThumbImgWr = PageImageWr.extend({

    className: 'FV-pgWr FV-pgWr-thumb',

    RENDER_LOADING_LABELS: 0,

    SUPPORTS_PAGE_TEXT_LAYER: 0,

   // TEXT_LAYER_VIEW: DocModePgImgWr.prototype.TEXT_LAYER_VIEW, -- this would work if ever desired

    /**
     * Add some extra items to the markup while inheriting the BasePg template.
     */
    onRender: function() {

        DocModePgImgWr.prototype.onRender.apply( this, arguments );

        var $thumbNum = $('<div class="FV-thumbNum">}</div>').html( this.model.get('number') );
        this.$el
            .prepend( $thumbNum )
            .toggleClass( 'active', this.options.vChannel.request('pageIsActivePage', this.model) );

    },

    // TODO: i think maybe refactor this ... trigger something up top that knows how to handle thumb, page, etc,
    // then that calls back down ...
    _postImgLoadOfPageWithUnknownDimensions: function() {

        PageImageWr.prototype._postImgLoadOfPageWithUnknownDimensions.apply( this, arguments );

        // Need to update after new dimensions -- prob want to make a channel call
        this.model.collection.setVOffsets();

    },

    // Diff: not updating call to images rendering
    onBeforeImageRequest: function() {
        this.$el.off('inview');
    },

    events: {

        'click': function() {

            var vCh = this.options.vChannel;
            if ( vCh.request('pageIsActivePage', this.model) )
                return;

            this.highlight();
            vCh.command('goToPage', vCh.request('getPageFromThumbModel',this.model ));
        }
    },

    highlight: function() {
        this.options.parent.triggerMethod('clearActiveThumb');
        this.$el.addClass('active');
    },

    onBeforeDestroy: DocModePgImgWr.prototype.onBeforeDestroy

});



module.exports = ThumbImgWr;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/thumbnail/pgThumb.js
 ** module id = 562
 ** module chunks = 0
 **/